// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"zp-z","imageAndVideoCount":"Ap-z","imageAndVideoContainer":"Bp-z","viewAllReviews":"Cp-z"};